// import React from 'react';
// import heroImage from '../../main_assets/hero2.png';
// import { FaInstagram, FaLinkedinIn, FaRedditAlien, FaPinterestP } from 'react-icons/fa';
// import './whatGPT3.css';

// const WhatGPT3 = () => {
//   return (
//     <div className="flex flex-col md:flex-row bg-[#f04f4f] min-h-screen items-center p-8 my-16">
//       <div style={{borderTop : "1px solid white", borderRight : "1px solid white", borderBottom : "1px solid white"}}>


//       </div>
//       <div className="image-section flex-1 md:flex-[0.65] pr-0 md:pr-8 mb-8 md:mb-0">
//         <div className="relative w-full h-full aspect-square md:aspect-auto">
//           <img
//             src={heroImage}
//             alt="Community Design"
//             className="w-full h-full object-cover"
//           />
//         </div>
//       </div>

//       <div className="text-section flex-1 md:flex-[0.35] pl-0 md:pl-4 text-center md:text-left">
//         <h1 className="text-white text-3xl md:text-5xl mb-4" style={{ fontFamily: "Poppins-SemiBold", fontWeight: "900" }}>
//           Join Our Community<br />for Design Lovers
//         </h1>
//         <p className="text-white text-base mb-6 max-w-xl mx-auto md:mx-0" style={{ fontFamily: "Poppins-Light", lineHeight: "1.2"}}>
//           Designed to the exacting European Passive House Standard, this is architect Cedric Burgers's family home.
//         </p>

//         <div className="flex justify-center md:justify-start space-x-6">
//           <a href="#" className="social-icon text-3xl">
//             <FaInstagram />
//           </a>
//           <a href="#" className="social-icon text-3xl">
//             <FaLinkedinIn />
//           </a>
//           <a href="#" className="social-icon text-3xl">
//             <FaRedditAlien />
//           </a>
//           <a href="#" className="social-icon text-3xl">
//             <FaPinterestP />
//           </a>
//         </div>
//       </div>
//     </div>

//   );
// };

// export default WhatGPT3;







import React from 'react';
import heroImage from '../../main_assets/hero2.png';
import { FaInstagram, FaLinkedinIn, FaRedditAlien, FaPinterestP } from 'react-icons/fa';
import './whatGPT3.css';

const WhatGPT3 = () => {
  return (
    <div className="flex flex-col md:flex-row bg-[#f04f4f] min-h-screen items-center p-4 md:p-8 my-8 md:my-16">
      <div 
        className="hidden md:block border-t border-r border-b border-white"
        style={{
          height: '80%', 
          width: '20px'
        }}
      >
        {/* Vertical border for desktop */}
      </div>

      <div className="flex flex-col md:flex-row w-full">
        <div className="image-section flex-1 md:flex-[0.65] pr-0 md:pr-8 mb-8 md:mb-0">
          <div className="relative w-full h-auto md:h-full aspect-square md:aspect-auto">
            <img
              src={heroImage}
              alt="Community Design"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="text-section flex-1 md:flex-[0.35] pl-0 md:pl-4 text-center md:text-left flex flex-col justify-center">
          <h1 
            className="text-white text-3xl md:text-5xl mb-4" 
            style={{ 
              fontFamily: "Poppins-SemiBold", 
              fontWeight: "900",
              lineHeight: "1.2"
            }}
          >
            Join Our Community<br />for Design Lovers
          </h1>
          <p 
            className="text-white text-base mb-6 max-w-xl mx-auto md:mx-0" 
            style={{ 
              fontFamily: "Poppins-Light", 
              lineHeight: "1.5"
            }}
          >
            Designed to the exacting European Passive House Standard, this is architect Cedric Burgers's family home.
          </p>

          <div className="flex justify-center md:justify-start space-x-6">
            <a 
              href="#" 
              className="social-icon text-white hover:text-gray-200 transition-colors duration-300 text-2xl md:text-3xl"
            >
              <FaInstagram />
            </a>
            <a 
              href="#" 
              className="social-icon text-white hover:text-gray-200 transition-colors duration-300 text-2xl md:text-3xl"
            >
              <FaLinkedinIn />
            </a>
            <a 
              href="#" 
              className="social-icon text-white hover:text-gray-200 transition-colors duration-300 text-2xl md:text-3xl"
            >
              <FaRedditAlien />
            </a>
            <a 
              href="#" 
              className="social-icon text-white hover:text-gray-200 transition-colors duration-300 text-2xl md:text-3xl"
            >
              <FaPinterestP />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhatGPT3;